export default __webpack_public_path__ + "static/media/0xb9f9e37c2cdbaff928c3da730b02f06fe09ae70e.36cf7b80.webp";